import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { getSpacing } from '../../const/spacing';
import { Icon } from '../Icon/Icon';
import { IconPlaceholder } from '../Icon/IconPlaceholder';
import { PlainButton } from '../PlainButton/PlainButton';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
import { getDynamicPinningTableStickyStyles } from './helpers/getDynamicPinningTableStickyStyles';
import { getSortIconName } from './helpers/getSortIconName';
const BORDER_RADIUS = sizes.dynamicTable.headerBorderRadius;
const StyledDynamicPinningTableHeaderCellContentWrapper = styled('div', ({ $totalColumns, $columnIndex }) => {
    const isFirstColumn = $columnIndex === 0;
    const isLastColumn = $columnIndex >= $totalColumns - 1;
    return {
        backgroundColor: staticColors.dynamicTableHeaderBackground,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        borderTopLeftRadius: isFirstColumn ? BORDER_RADIUS : undefined,
        borderBottomLeftRadius: isFirstColumn ? BORDER_RADIUS : undefined,
        borderTopRightRadius: isLastColumn ? BORDER_RADIUS : undefined,
        borderBottomRightRadius: isLastColumn ? BORDER_RADIUS : undefined,
    };
});
const StyledDynamicPinningTableHeaderCellSticky = styled('th', ({ $isPinned, $stickyLeftPx, $isMeasured, $pinnedWidthPx }) => {
    const stickyStyles = getDynamicPinningTableStickyStyles({
        isPinned: $isPinned,
        isMeasured: $isMeasured,
        stickyLeftPx: $stickyLeftPx,
        pinnedWidthPx: $pinnedWidthPx,
    });
    return {
        padding: `0 0 ${getSpacing('3/2')} 0`,
        ...stickyStyles,
    };
});
export const DynamicPinningTableHeaderCell = ({ totalColumns, columnIndex, isSortable, pinningInfo, headerCellRef, sortDirection, onClick, children, }) => {
    const sortIconName = sortDirection
        ? getSortIconName(sortDirection)
        : undefined;
    const shouldShowSortIcon = isSortable && !!sortIconName;
    const sortIcon = shouldShowSortIcon ? (_jsx(Icon, { name: sortIconName })) : (_jsx(IconPlaceholder, {}));
    const cellContent = (_jsxs(FlexContainer, { direction: 'row', verticalAlign: 'center', spacingHorizontal: '3/2', spacingVertical: true, children: [_jsx(Text, { variant: 'b2', color: 'dark', underline: isSortable, as: 'div', children: children }), sortIcon] }));
    const content = isSortable ? (_jsx(PlainButton, { onClick: onClick, children: cellContent })) : (cellContent);
    return (_jsx(StyledDynamicPinningTableHeaderCellSticky, { ref: headerCellRef, $isPinned: pinningInfo?.isPinned, $stickyLeftPx: pinningInfo?.stickyLeftPx, $isMeasured: pinningInfo?.isStickyLeftPxMeasured, $pinnedWidthPx: pinningInfo?.pinnedWidthPx, children: _jsx(StyledDynamicPinningTableHeaderCellContentWrapper, { $totalColumns: totalColumns, $columnIndex: columnIndex, children: content }) }));
};
